define("shared/components/shared/post/copy/modal/index", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/debug", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "tracked-built-ins", "later/utils/constants", "later/utils/constants/segment-events", "later/utils/time-format", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _debug, _object, _service, _component2, _tracking, _emberConcurrency, _trackedBuiltIns, _constants, _segmentEvents, _timeFormat, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _updateSelectedProfiles, _trackStartedCopy;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/debug",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"tracked-built-ins",0,"later/utils/constants",0,"later/utils/constants/segment-events",0,"later/utils/time-format",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Modal @close={{this.closeModal}} @closeButtonQaClass="qa--modal_close_btn" @focusTrap={{true}} as |modal|>
    <modal.card @portrait={{true}} data-test-id="copy-post-modal">
      <modal.card-header
        @title={{t (if @post.isDraft "post.copy_post.copy_draft" "post.copy_post.copy_post")}}
        class="qa--modal_title"
      />
  
      <modal.card-body class="u--p__t__0">
        <p class="u--text--bold qa--modal_available_title">
          {{t (if @post.isDraft "post.copy_post.modal.description_draft" "post.copy_post.modal.description")}}
        </p>
  
        <Shared::Post::ProfileSelector
          @maxSelectedProfiles={{this.MAX_SELECTED_PROFILES}}
          @post={{@post}}
          @socialProfileStates={{this.socialProfileStates}}
        />
  
      </modal.card-body>
  
      <modal.card-footer>
        <Shared::Ui::Button
          @onClick={{@closeModal}}
          @text={{t "shared_words.cancel"}}
          @variant="outline"
          class="u--float--left qa--modal_cancel_btn"
        />
  
        <Shared::Ui::Button
          @isDisabled={{this.disableCopyButton}}
          @promise={{this.copyPost}}
          @text={{t (if @post.isDraft "post.copy_post.copy_draft" "post.copy_post.copy_post")}}
          class="u--float--right qa--modal_copy_button"
          data-test-id="copy-post-button"
        />
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "SnIx+Bg6",
    "block": "[[[8,[39,0],null,[[\"@close\",\"@closeButtonQaClass\",\"@focusTrap\"],[[30,0,[\"closeModal\"]],\"qa--modal_close_btn\",true]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],[[24,\"data-test-id\",\"copy-post-modal\"]],[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card-header\"]],[[24,0,\"qa--modal_title\"]],[[\"@title\"],[[28,[37,1],[[52,[30,2,[\"isDraft\"]],\"post.copy_post.copy_draft\",\"post.copy_post.copy_post\"]],null]]],null],[1,\"\\n\\n    \"],[8,[30,1,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,2],[14,0,\"u--text--bold qa--modal_available_title\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[[52,[30,2,[\"isDraft\"]],\"post.copy_post.modal.description_draft\",\"post.copy_post.modal.description\"]],null]],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[8,[39,3],null,[[\"@maxSelectedProfiles\",\"@post\",\"@socialProfileStates\"],[[30,0,[\"MAX_SELECTED_PROFILES\"]],[30,2],[30,0,[\"socialProfileStates\"]]]],null],[1,\"\\n\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,4],[[24,0,\"u--float--left qa--modal_cancel_btn\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,3],[28,[37,1],[\"shared_words.cancel\"],null],\"outline\"]],null],[1,\"\\n\\n      \"],[8,[39,4],[[24,0,\"u--float--right qa--modal_copy_button\"],[24,\"data-test-id\",\"copy-post-button\"]],[[\"@isDisabled\",\"@promise\",\"@text\"],[[30,0,[\"disableCopyButton\"]],[30,0,[\"copyPost\"]],[28,[37,1],[[52,[30,2,[\"isDraft\"]],\"post.copy_post.copy_draft\",\"post.copy_post.copy_post\"]],null]]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"modal\",\"@post\",\"@closeModal\"],false,[\"shared/modal\",\"t\",\"if\",\"shared/post/profile-selector\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/post/copy/modal/index.hbs",
    "isStrictMode": false
  });
  let CopyModalComponent = _exports.default = (_dec = (0, _service.inject)('schedule/post'), (_class = (_updateSelectedProfiles = /*#__PURE__*/new WeakSet(), _trackStartedCopy = /*#__PURE__*/new WeakSet(), class CopyModalComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _classPrivateMethodInitSpec(this, _trackStartedCopy);
      _classPrivateMethodInitSpec(this, _updateSelectedProfiles);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _initializerDefineProperty(this, "schedulePost", _descriptor3, this);
      _initializerDefineProperty(this, "router", _descriptor4, this);
      _initializerDefineProperty(this, "segment", _descriptor5, this);
      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor6, this);
      _initializerDefineProperty(this, "socialProfileStates", _descriptor7, this);
      _defineProperty(this, "MAX_SELECTED_PROFILES", _constants.MAX_SELECTED_SOCIAL_PROFILES_COUNT);
      _defineProperty(this, "TIME_OFFSET_MIN", 30);
      _defineProperty(this, "copyPost", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const targetProfiles = [];
          let queryParams = {};
          this.selectedProfiles.forEach(state => {
            _classPrivateMethodGet(this, _updateSelectedProfiles, _updateSelectedProfiles2).call(this, state.socialProfile);
            if (this.isDraftPost) {
              const isListView = this.router.currentRouteName?.includes('list');
              queryParams = {
                backTo: isListView ? 'cluster.schedule.list' : 'cluster.schedule.calendar',
                draft: true,
                scheduledTime: this.post.scheduledTime
              };
              targetProfiles.push(state.socialProfile);
            } else {
              const scheduledTime = this.isScheduledPost ? this.post.scheduledTime : (0, _timeFormat.timestamp)() + _timeFormat.convert.minutes(this.TIME_OFFSET_MIN).toSeconds();
              queryParams = {
                scheduledTime
              };
              targetProfiles.push(state.socialProfile);
            }
          });
          this.selectedSocialProfiles.selectExactly(targetProfiles);
          const targetProfileIds = targetProfiles.map(socialProfile => socialProfile.id);
          this.schedulePost.copyPost(this.post, targetProfileIds, queryParams);
          if (this.isMediaRemoved) {
            this.alerts.warning(this.intl.t('alerts.posts.copy.could_not_copy.message'), {
              title: this.intl.t('alerts.posts.copy.could_not_copy.title')
            });
          }
        }
      }), null, "copyPost", null));
      (false && !(typeof args.post === 'object') && (0, _debug.assert)('Must pass post to Shared::Post::Copy::Modal', typeof args.post === 'object'));
      _classPrivateMethodGet(this, _trackStartedCopy, _trackStartedCopy2).call(this);
    }
    get currentRouteName() {
      return this.router.currentRouteName;
    }
    get selectedProfiles() {
      return this.socialProfileStates.filter(state => state.isAvailable && state.isSelected);
    }
    get disableCopyButton() {
      return this.selectedProfiles.length === 0;
    }
    get post() {
      return this.args.post;
    }
    get isDraftPost() {
      return this.post.isDraft;
    }
    get isScheduledPost() {
      return this.post.scheduledInFuture;
    }
    get isMediaRemoved() {
      const hasRemovedMedia = this.post.get('postMediaItems').any(pmi => !pmi.get('mediaItem').get('active'));
      return hasRemovedMedia && !this.post.isText;
    }
    closeModal() {
      this.args.closeModal();
      this.router.replaceWith('cluster.schedule.calendar.post.edit', this.post.id, {
        queryParams: {
          copy: undefined
        }
      });
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "schedulePost", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "socialProfileStates", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return new _trackedBuiltIns.TrackedArray([]);
    }
  }), _applyDecoratedDescriptor(_class.prototype, "closeModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype)), _class));
  function _updateSelectedProfiles2(socialProfile) {
    const isProfileAlreadySelected = this.selectedSocialProfiles.profileIds.any(id => {
      return id === socialProfile.id;
    });
    if (isProfileAlreadySelected) {
      return;
    }
    if (this.selectedSocialProfiles.profiles.length < _constants.MAX_SELECTED_SOCIAL_PROFILES_COUNT) {
      this.selectedSocialProfiles.addSingleProfile(socialProfile);
    } else {
      // Note: replace the first profile that is not the original post's profile
      const selectedProfiles = this.selectedSocialProfiles.profiles;
      const currentProfileId = this.args.post.get('socialProfile')?.get('id');
      const profileToReplace = profile => profile.id !== currentProfileId;
      const index = selectedProfiles.findIndex(profileToReplace);
      if (index >= 0) {
        selectedProfiles[index] = socialProfile;
      }
      this.selectedSocialProfiles.selectExactly(selectedProfiles);
    }
  }
  function _trackStartedCopy2() {
    let postType = 'null_value';
    if (this.isDraftPost) {
      postType = 'draft';
    } else if (this.isScheduledPost) {
      postType = 'scheduled';
    } else {
      postType = 'published';
    }
    const area = this.currentRouteName?.includes('list') ? 'list' : 'calendar';
    this.segment.track(_segmentEvents.SegmentEventTypes.StartedCopyPost, {
      original_profile_type: this.args.post.get('socialProfile')?.get('profileType') || 'undefined',
      original_source: postType,
      area,
      high_performing_content: this.args.post.isHighPerformingPost
    });
    this.segment.track(_segmentEvents.SegmentEventTypes.StartedSchedulingPost, {
      area: 'copy',
      high_performing_content: this.args.post.isHighPerformingPost
    });
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CopyModalComponent);
});